import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SectionHeading from "@/components/feature/SectionHeading";
import ContactForm from "@/pages/about/components/ContactForm";

const values = [
  {
    icon: "ri-newspaper-line",
    title: "资讯专业",
    desc: "专注韩国女主播领域，持续追踪新闻动态与行业话题，内容分类清晰、更新及时。",
  },
  {
    icon: "ri-image-2-line",
    title: "多媒呈现",
    desc: "以高清写真与视频专辑为载体，让每一位主播的魅力被更生动地看见与收藏。",
  },
  {
    icon: "ri-shield-star-line",
    title: "信息清晰",
    desc: "主播资料结构化整理，关注度数据一目了然，帮你快速了解喜爱的主播。",
  },
];

const stats = [
  { value: "48+", label: "收录主播" },
  { value: "320+", label: "资讯动态" },
  { value: "1200+", label: "高清写真" },
  { value: "260+", label: "视频内容" },
];

const contacts = [
  { icon: "ri-mail-line", label: "商务合作", value: "business@kstar-demo.com" },
  { icon: "ri-customer-service-2-line", label: "内容投稿", value: "submit@kstar-demo.com" },
  { icon: "ri-map-pin-2-line", label: "办公地址", value: "首尔特别市麻浦区上岩洞演示大厦 12F" },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-youtube-fill", label: "YouTube" },
  { icon: "ri-instagram-line", label: "Instagram" },
  { icon: "ri-tiktok-fill", label: "TikTok" },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们 – 韩国女主播"
        description="了解韩国女主播资讯门户的品牌定位与使命：专注韩国女主播资讯领域，聚合新闻动态、个人资料、视频与高清写真，并提供联系方式与商务合作渠道。"
        keywords="关于韩国女主播,韩国女主播网站,韩国主播资讯,商务合作,联系方式"
        canonical="/about"
      />

      <div className="mx-auto max-w-[1440px] px-4 md:px-8 py-6 md:py-8">
        <Breadcrumb items={[{ label: "关于我们" }]} />

        <header className="mt-4 rounded-lg bg-primary-700 text-background-50 p-6 md:p-12 overflow-hidden">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 mb-4">
            关于韩国女主播
          </span>
          <h1 className="text-2xl md:text-4xl font-heading font-bold mb-4 max-w-3xl leading-tight">
            专注韩国女主播资讯与多媒体内容
          </h1>
          <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-3xl">
            韩国女主播网站致力于为关注韩国娱乐文化的用户提供一站式资讯浏览体验。我们聚合最新主播动态、结构化个人资料、视频专辑与高清写真，帮助粉丝全面了解主播圈内信息，发现并追随自己喜爱的主播。
          </p>
        </header>

        <section className="mt-10 md:mt-14">
          <SectionHeading title="我们的定位" subtitle="为什么选择关注我们" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {values.map((v) => (
              <article key={v.title} className="rounded-lg bg-background-100 border border-background-200/70 p-5">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 mb-4">
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading font-semibold text-foreground-950 mb-2">{v.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-10 md:mt-14">
          <div className="rounded-lg bg-secondary-100 border border-secondary-200/70 grid grid-cols-2 lg:grid-cols-4 divide-x divide-background-200/70">
            {stats.map((s) => (
              <div key={s.label} className="p-6 text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-700">{s.value}</p>
                <p className="text-xs md:text-sm text-foreground-600 mt-1">{s.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-10 md:mt-14">
          <SectionHeading title="联系我们" subtitle="投稿、合作与内容纠错欢迎随时联系" accent />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              <ContactForm />
            </div>

            <div className="space-y-6">
              <div className="rounded-lg bg-background-100 border border-background-200/70 p-5">
                <h3 className="font-heading font-semibold text-foreground-950 mb-4">联系方式</h3>
                <ul className="space-y-4">
                  {contacts.map((c) => (
                    <li key={c.label} className="flex items-start gap-3">
                      <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-primary-600 text-background-50">
                        <i className={`${c.icon} text-lg`}></i>
                      </span>
                      <span className="min-w-0">
                        <span className="block text-xs text-foreground-500">{c.label}</span>
                        <span className="block text-sm font-medium text-foreground-900 break-all">{c.value}</span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-lg bg-background-100 border border-background-200/70 p-5 flex flex-col items-center text-center">
                <h3 className="font-heading font-semibold text-foreground-950 mb-3">关注我们的社交账号</h3>
                <div className="w-36 h-36 rounded-lg overflow-hidden bg-background-50 border border-background-200/70 mb-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=clean%20minimal%20black%20and%20white%20QR%20code%20pattern%20on%20white%20background%2C%20simple%20square%20graphic%20design%2C%20high%20contrast&width=400&height=400&seq=about-qr&orientation=squarish"
                    alt="社交媒体二维码"
                    title="韩国女主播社交账号二维码"
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-xs text-foreground-500 mb-4">扫码关注，第一时间获取主播最新动态</p>
                <div className="flex items-center gap-3">
                  {socials.map((s) => (
                    <a
                      key={s.label}
                      href="https://911fanchac.asia"
                      rel="nofollow"
                      aria-label={s.label}
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 text-foreground-700 hover:bg-accent-500 hover:text-background-50 transition-colors"
                    >
                      <i className={`${s.icon} text-lg`}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}